import React from "react";

const DeezerWidget = ({ content }) => {
  /*
   * Using the Deezer Widget-Functionality to embed an iframe.
   * Users only need to insert a Deezer page (artist, track, album or playlist).
   * We strip the type and ID out of the url and insert them into the given Iframe Boilerplate.
   * Functionality Infos can be found here: https://widget.deezer.com/?type=artist&id=52512372
   * Deezer URLs are structured as https://www.deezer.com/<locale>/<type>/<id>, e.g.
   * https://www.deezer.com/de/artist/52512372 or https://www.deezer.com/de/track/1234567890
   */

  if (content.fieldDeezer && content.fieldDeezer.uri) {
    // filter(Boolean) drops empty segments from a leading/trailing slash, so
    // the id is reliably the last segment and the type the one before it,
    // regardless of whether a locale prefix is present in the url.
    const segments = content.fieldDeezer.uri.path.split("/").filter(Boolean);
    const deezerId = segments[segments.length - 1];
    const deezerType = segments[segments.length - 2];

    // The "top_tracks" widget view only exists for the artist type; other
    // content types (track, album, playlist, ...) are embedded directly.
    const widgetPath =
      deezerType === "artist"
        ? `${deezerType}/${deezerId}/top_tracks?tracklist=false`
        : `${deezerType}/${deezerId}`;

    return (
      <div className="deezer-widget">
        <iframe
          title="deezer-widget"
          src={`https://widget.deezer.com/widget/dark/${widgetPath}`}
          width="100%"
          height="300"
          frameBorder="0"
          allowTransparency="true"
          allow="encrypted-media;clipboard-write"
        />
      </div>
    );
  }
};

export default DeezerWidget;
